@use 'src/globals/main';

pn-icon {
  display: inline-block;
  vertical-align: top;
  /** @prop --pn-icon-color: The icon color. */
  --pn-icon-color: main.$gray900;

  &[small] svg {
    height: 1em;
    width: 1em;
  }

  svg {
    display: block;
    height: 1.5em;
    width: 1.5em;
  }

  .pn-icon-svg > {
    circle,
    path {
      fill: var(--pn-icon-color);
      @include main.pn-transition('fill');
    }
  }
}
